import React from 'react';

import classNames from 'classnames';

export default function TablePageLayout({
  children,
  title,
  className,
  contentClassName,
}) {
  return (
    <section
      className={classNames(
        'bg-gray-50 dark:bg-gray-900 p-3 sm:p-5 antialiased',
        className
      )}
    >
      <div
        className={classNames(
          'mx-auto max-w-screen-xl px-4 lg:px-12',
          contentClassName
        )}
      >
        <h2 className="mb-4 text-xl font-bold text-gray-900 dark:text-white">
          {title}
        </h2>
        {children}
      </div>
    </section>
  );
}
